import { useTranslation } from "react-i18next";

const OPTIONS = [
  { code: "en", label: "EN", flag: "https://flagcdn.com/w40/us.png", srLabel: "English (USA)" },
  { code: "fr", label: "FR", flag: "https://flagcdn.com/w40/ca.png", srLabel: "Français (Canada)" },
];

export default function LanguageToggle({ className = "" }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("fr") ? "fr" : "en";

  const set = (code) => {
    if (code !== current) i18n.changeLanguage(code);
  };

  return (
    <div data-testid="language-toggle" className={`inline-flex items-center gap-1 rounded-full border border-border bg-white p-1 ${className}`}>
      {OPTIONS.map((o) => {
        const active = current === o.code;
        return (
          <button
            key={o.code}
            data-testid={`lang-${o.code}`}
            onClick={() => set(o.code)}
            aria-label={o.srLabel}
            aria-pressed={active}
            className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1.5 text-sm font-bold transition-colors ${active ? "bg-foreground text-white" : "text-foreground/60 hover:text-foreground"}`}
          >
            <img src={o.flag} alt="" className="h-4 w-6 object-cover rounded-[2px]" />
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
